import { SITE_URL } from '../resolveSEO';
import type { ResolvedSEO } from '../types';

export const buildWebPage = (resolved: ResolvedSEO) => ({
  '@type': 'WebPage',
  '@id': `${resolved.url}#webpage`,
  url: resolved.url,
  name: resolved.title,
  description: resolved.description,
  isPartOf: {
    '@id': `${SITE_URL}/#website`,
  },
  about: {
    '@id': `${SITE_URL}/#organization`,
  },
  primaryImageOfPage: {
    '@type': 'ImageObject',
    url: resolved.image,
    width: 1200,
    height: 630,
  },
});
